import { TeamMember } from "@/models";
import { PaginationResponse } from "../models/pagination.model";
import { Team } from "../models/team.model";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

export default {
  getTeams(page: number = 1) {
    return axios.get().get<PaginationResponse<Team[]>>(`/teams`, {
      params: {
        page
      }
    });
  },
  postTeam(payload: Team) {
    let formData = new FormData();
    Object.keys(payload).forEach(key => {
      const value = (payload as any)[key];
      if (value !== undefined) {
        formData.append(key, value);
      }
    });
    return axios.get().post<ApiResponse<Team>>(`/teams`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  putTeam(teamId: number, payload: Team) {
    let formData = new FormData();
    Object.keys(payload).forEach(key => {
      const value = (payload as any)[key];
      if (value !== undefined) {
        formData.append(key, value);
      }
    });
    return axios.get().post<ApiResponse<Team>>(`/teams/${teamId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  getTeam(teamId: number) {
    return axios.get().get<ApiResponse<Team>>(`/teams/${teamId}`);
  },
  getTeamMembers(teamId: number) {
    return axios.get().get<ApiResponse<TeamMember[]>>(`/teams/${teamId}/teammembers`);
  }
};
